import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showModal } from 'Core/redux/main/slice';
import { deleteProduction, quarantineProduction, releaseProduction } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { Filter, Sliders } from 'feather-icons-react/build/IconComponents';
import { ImageWithBasePath } from 'Core/components';
import Select from 'react-select';
import { actions as productionActions } from './store/slice';
import { selectProductionFilterVisible } from './store/selectors';
const { PRODUCTION_ADD_EDIT } = MODAL_TYPES;

const initData = {
  id: 0,
  assetNumber: '',
  downloadedFile: '',
  productionDate: '',
  productionScan: '',
  productionScanDate: '',
  iqmsProductionDate: '',
  locationName: '',
  partNumber: '',
  scanUserName: '',
  serialNumber: '',
  shipmentASP: '',
  userId: '',
  userName: '',
  isQuarantine: '',
};

const { setFilterVisible, setSearchText } = productionActions;
const ProductionSerialNumberTable = ({ data, onChanges }) => {
  const [partInputs, setPartInputs] = useState(initData);
  const [parts, setParts] = useState(data);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [searchText, setSearchTextValue] = useState('');
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (onChanges) onChanges(parts);
  }, [parts, onChanges]);

  const handleBulkAction = async action => {
    if (selectedRows.length === 0) {
      alert('Please select atlease one item');
      return;
    }

    // Check for already quarantined/released items
    if (action === 'quarantine') {
      const alreadyQuarantined = selectedRows.filter(row => row.isQuarantine === 'Y');
      if (alreadyQuarantined.length > 0) {
        alert(
          `Invalid selection: ${alreadyQuarantined.length} item(s) are already quarantined.\nPlease review your selection.`,
        );
        return;
      }
    } else if (action === 'release') {
      const notQuarantined = selectedRows.filter(row => row.isQuarantine !== 'Y');
      if (notQuarantined.length > 0) {
        alert(
          `Invalid selection: ${notQuarantined.length} item(s) are not in quarantine.\nPlease review your selection.`,
        );
        return;
      }
    }

    setIsLoading(true);
    const actionFunction = action === 'quarantine' ? quarantineProduction : releaseProduction;

    try {
      const payload = {
        userId: localStorage.getItem('UserId'),
        parts: selectedRows.map(record => ({
          partId: record.partId,
          serialNumber: record.serialNumber,
        })),
      };

      // Make a single API call with all records
      await dispatch(actionFunction(payload));

      // Update the local state
      const updatedParts = parts.map(part => {
        if (selectedRows.some(selected => selected.serialNumber === part.serialNumber)) {
          return { ...part, isQuarantine: action === 'quarantine' ? 'Y' : 'N' };
        }
        return part;
      });

      setParts(updatedParts);
      setSelectedRows([]); // Clear selection after action
    } catch (error) {
      console.error('Error processing bulk action:', error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextValue(newSearchText);
    //parts.filters.searchText=newSearchText;
    dispatch(setSearchText(newSearchText));
  };
  // Row selection configuration
  const rowSelection = {
    selectedRowKeys: selectedRows.map(row => row.serialNumber),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRows(selectedRows);
    },
  };
  const oldandlatestvalue = [
    { value: 'date', label: 'Sort by Date' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
  ];

  const columns = [
    {
      title: 'Serial Number',
      dataIndex: 'serialNumber',
      sorter: (a, b) => a.serialNumber.length - b.serialNumber.length,
    },
    {
      title: 'Part Number',
      dataIndex: 'partNumber',
      sorter: (a, b) => a.partNumber.length - b.partNumber.length,
    },
    {
      title: 'Inv. Date',
      dataIndex: 'productionDate',
      sorter: (a, b) => a.productionDate.length - b.productionDate.length,
    },
    {
      title: 'Inv. Scan',
      dataIndex: 'productionScan',
      sorter: (a, b) => a.productionScan.length - b.productionScan.length,
    },
    {
      title: 'Inv. Scan Date',
      dataIndex: 'productionScanDate',
      sorter: (a, b) => a.productionScanDate.length - b.productionScanDate.length,
    },
    {
      title: 'Location Name',
      dataIndex: 'locationName',
      sorter: (a, b) => a.locationName.length - b.locationName.length,
    },

    {
      title: 'Is Quarantine?',
      dataIndex: 'isQuarantine',
      sorter: (a, b) => a.isQuarantine.length - b.isQuarantine.length,
    },
  ];

  return (
    <div>
      <div className="mb-3">
        <button className="btn btn-warning me-2" onClick={() => handleBulkAction('quarantine')}>
          Quarantine Selected
        </button>
        <button className="btn btn-info me-2" onClick={() => handleBulkAction('release')}>
          Release Selected
        </button>
        {selectedRows.length > 0 && (
          <span className="ms-2">{selectedRows.length} items selected</span>
        )}
      </div>

      <div className="table-responsive product-list">
        {isLoading && <LoadingSpinner />}
        <Table
          rowSelection={rowSelection}
          rowKey="serialNumber"
          columns={columns}
          dataSource={parts}
        />
      </div>
    </div>
  );
};

export default ProductionSerialNumberTable;
